import {IAudio} from "modules/reducers/audio";
import {createAction} from "redux-act";


export const fetchAudioActionSuccess = createAction<IAudio>('fetchAudioActionSuccess');
export const fetchAudioActionFailed = createAction('fetchAudioActionFailed');
export const startBackgroundMusic = createAction('startBackgroundMusic');

export const runAudioFor = createAction<string>('runAudioFor');
export const runAudioEffect = createAction<string>('runAudioEffect');
export const saveBGSoundID = createAction<number>('saveBGSoundID');
export const saveEffectsSoundID = createAction<number>('saveEffectsSoundID');
export const fadeInBGSound = createAction('fadeInBGSound');
export const fadeOUTBGSound = createAction('fadeOUTBGSound');